"use client"

import { motion } from "framer-motion"
import { Card, CardContent } from "./ui/card"

const testimonials = [
  {
    name: "Dr. Priya Sharma",
    location: "Mumbai",
    roomImage: "/VoicefrmBeuty_1.png",
    quote:
      "When we began our home renovation, we wanted pieces that felt timeless but also personal. I stumbled upon mi casa su casa and immediately felt like I had discovered a secret place where design meets soul. Every piece we bought has become a conversation starter—guests always ask where it's from. More than the products, it was the warmth of the team, the thoughtful guidance, and the genuine passion for design that made the experience unforgettable. My home doesn't just look beautiful now—it feels like it tells our story.",
  },
  {
    name: "Arjun Mehta",
    location: "Delhi",
    roomImage: "/VoicefrmBeuty_2.png",
    quote:
      "I've bought furniture before, but never like this. From the very first call, it was as if they could see exactly what I envisioned for my living space. They didn't just sell me a coffee table; they helped me create a room where my family now gathers every evening. The craftsmanship, the quality, the detail—it's all exceptional. But what stood out most was how invested they were in making sure everything felt perfect for us. They made our house feel like a home.",
  },
  {
    name: "Kavya Nair",
    location: "Bangalore",
    roomImage: "/VoicefrmBeuty_3.png",
    quote:
      "I wanted my new apartment to feel sophisticated yet welcoming—somewhere I could relax after work but also host friends without feeling it was too formal. Mi Casa Su Casa nailed it. From suggesting the perfect dining table to helping me choose accent pieces that tied the space together, their advice was priceless. It's not just the furniture; it's the way they think about spaces and how people live in them. Now, every time I walk through my door, I smile.",
  },
  {
    name: "Rohit Gupta",
    location: "Pune",
    roomImage: "/VoicefrmBeuty_4.png",
    quote: "Working with Mi Casa Su Casa  was like having a design-savvy friend who truly understood us. They didn't push trends or generic looks—instead, they curated pieces that felt authentic to our taste. The quality is remarkable, but the experience is what set them apart. From careful packaging to follow-ups after delivery, they made sure we felt taken care of every step of the way. My home feels more 'me' than ever, and that's priceless.",
  },
]

export default function TestimonialWall() {
  return (
    <section className="bg-white pt-24 pb-6">
      <div className="container mx-auto px-4">
        <motion.h2
          className="mb-4 text-center font-serif text-3xl font-light md:text-4xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          Voices from Beautiful Homes
        </motion.h2>

        <motion.p
          className="mx-auto mb-16 max-w-2xl text-center text-muted-foreground"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Hear from those who have welcomed our pieces into their lives.
        </motion.p>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
            >
              <Card className="h-full overflow-hidden border border-stone-200 shadow-sm">
                <div className="relative h-48 w-full">
                  <img
                    src={testimonial.roomImage || "/placeholder.svg"}
                    alt={`${testimonial.name}'s home`}
                    className="w-full h-full object-cover"
                  />
                </div>

                <CardContent className="p-6 pt-5">
                  <div className="mb-3">
                    <h3 className="font-semibold text-base mb-1">{testimonial.name}</h3>
                    <p className="text-sm text-muted-foreground">{testimonial.location}</p>
                  </div>

                  <blockquote className="font-serif text-base italic leading-relaxed text-gray-700">
                    "{testimonial.quote}"
                  </blockquote>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
} 